export default "__VITE_ASSET__CmKyQ1hk__"